import React, { useEffect, useMemo, useState } from "react";
import { Button, Fab, Grid, Typography, useTheme } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { gridSpacing } from "../../../../../store/constants";
import UserDetailCard from "./user-details-card";
import UserInfoCard from "./user-info-card";
import EditIcon from "@mui/icons-material/Edit";
import ViewEditDialog from "../../../../../utils/ui-components/ViewEditDialog";
import EditUser from "../../parentUser/edit-user";
import { _setImage, formatMobile } from "../../../../../utils/utils";
import CredentialsManagement from "./credentials";
import { UserService } from "../../../../../assets/_services/user-service";
import { RateCardService } from "../../../../../assets/_services/rate-card-service";
import { getState, SET_BREADCRUMBS } from "../../../../../redux/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import DataCredentialsManagement from "./dataCredentials";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

const ACCOUNT_TYPES = [
  {
    value: 1,
    label: "Prepaid",
  },
  {
    value: 2,
    label: "Postpaid",
  },
];

const INDUSTRY_TYPES = [
  {
    value: 1,
    label: "Construction",
  },
  {
    value: 2,
    label: "Retail",
  },
  {
    value: 3,
    label: "Transportation",
  },
  {
    value: 4,
    label: "Financial Service",
  },
  {
    value: 5,
    label: "Agriculture",
  },
  {
    value: 6,
    label: "Education",
  },
  {
    value: 7,
    label: "Technology",
  },
  {
    value: 8,
    label: "Health Care",
  },
];
export interface UserEditValues {
  id: number;
  profileImage: string | object;
  representativeName: string;
  email: string;
  nid: string;
  vat: string;
  companyName: string;
  businessName: string;
  companyContact: string;
  mobile: string;
  companyLocation: string;
  industryType: string;
  accountType: string;
  username: string;
  password: string;
  confirmPassword: string;
  status: boolean;
  isShowRateCard: boolean;
  enableUserCreation: boolean;
  enableApiCreation: boolean;
  enableReportDownload: boolean;
  isCampaignNumberHash: boolean;
  enableRewardCampaignCreation: boolean;
  rateCardId: number | string;
  dataRateCardId: number | string;
  joinedDate: string;
  smsOperatorConfguraion: {
    all: boolean;
    defaultOperator: string | number;
    robi: {
      isUse: boolean;
      isUpdate: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
    };
    tl: {
      isUpdate: boolean;
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
      acode: string;
    };
    bl: {
      isUpdate: boolean;
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
      billmsisdn: string;
    };
    gp: {
      isUpdate: boolean;
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
      billmsisdn: string;
    };
  };
  rewardOperatorConfguraion: {
    all: boolean;
    robi: {
      isUpdate: boolean;
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
    };
    tl: {
      isUpdate: boolean;
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
    };
    bl: {
      isUpdate: boolean;
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      clientId: string;
      grantType: string;
      scope: string;
      clientSecret: string;
      senderMsisdn: string;
    };
    gp: {
      isUpdate: boolean;
      isUse: boolean;
      systemOperatorId: number;
      clientId: string;
      clientSecret: string;
      grantType: string;
    };
  };
}

const INITIAL_FORM_STATE: UserEditValues = {
  id: 0,
  profileImage: "",
  representativeName: "",
  email: "",
  nid: "",
  vat: "",
  companyName: "",
  businessName: "",
  companyContact: "",
  mobile: "",
  companyLocation: "",
  industryType: "",
  accountType: "",
  username: "",
  password: "",
  confirmPassword: "",
  rateCardId: "",
  dataRateCardId: "",
  status: true,
  enableUserCreation: true,
  enableApiCreation: true,
  isShowRateCard: true,
  enableReportDownload: true,
  isCampaignNumberHash: true,
  enableRewardCampaignCreation: false,
  joinedDate: dayjs().toISOString(),
  smsOperatorConfguraion: {
    all: true,
    defaultOperator: "",
    robi: {
      isUse: true,
      isUpdate: true,
      systemOperatorId: 1,
      userName: "",
      password: "",
      tps: "",
    },
    tl: {
      isUse: true,
      isUpdate: true,
      systemOperatorId: 2,
      userName: "",
      password: "",
      tps: "",
      acode: "",
    },
    bl: {
      isUse: true,
      isUpdate: true,
      systemOperatorId: 3,
      userName: "",
      password: "",
      tps: "",
      billmsisdn: "",
    },
    gp: {
      isUse: true,
      isUpdate: true,
      systemOperatorId: 4,
      userName: "",
      password: "",
      tps: "",
      billmsisdn: "",
    },
  },
  rewardOperatorConfguraion: {
    all: true,
    robi: {
      isUpdate: true,
      isUse: true,
      systemOperatorId: 1,
      userName: "",
      password: "",
    },
    tl: {
      isUse: true,
      isUpdate: true,
      systemOperatorId: 2,
      userName: "",
      password: "",
    },
    bl: {
      isUse: true,
      isUpdate: true,
      systemOperatorId: 3,
      userName: "",
      password: "",
      clientId: "",
      grantType: "",
      scope: "",
      clientSecret: "",
      senderMsisdn: "",
    },
    gp: {
      isUpdate: true,
      isUse: true,
      systemOperatorId: 4,
      clientId: "",
      clientSecret: "",
      grantType: "",
    },
  },
};

function ViewUser() {
  let { id } = useParams();
  let { state } = useLocation();
  const theme: any = useTheme();
  const navigate = useNavigate();
  const authState = useSelector((state: any) => state.auth.authData);
  const user = getState(authState);
  const dispatch = useDispatch();

  const [isLoading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [initialItem, setInitialItem] = useState(INITIAL_FORM_STATE);
  const [rateCard, setRateCard] = useState([]);
  const [dataRateCard, setDataRateCards] = useState([]);
  const [ownerData, setOwnerData] = useState({
    id: 0,
    profileImage: {},
    representativeName: "",
    email: "",
    nid: "",
    vat: "",
    companyName: "",
    businessName: "",
    companyContact: "",
    mobile: "",
    companyLocation: "",
    industryType: "",
    accountType: "",
    username: "",
    password: "",
    confirmPassword: "",
    rateCardId: 0,
    dataRateCardId: 0,
    status: false,
    enableUserCreation: false,
    enableApiCreation: false,
    isShowRateCard: false,
    enableReportDownload: false,
    enableRewardCampaignCreation: false,
    isCampaignNumberHash: false,
  });

  const [systemOperatorData, setSystemOperatorData]: any[] = useState();

  useEffect(() => {
    fetchUser();
    fetchRateCards();
  }, []);

  useEffect(() => {
    dispatch({
      type: SET_BREADCRUMBS,
      payload: [
        { name: "Home", path: "/Dashboard", bold: true },
        { name: "Users", path: "/config/users", bold: true },
        { name: `${initialItem.representativeName}`, path: null, bold: false },
      ],
    });
  }, [initialItem]);

  const fetchUser = () => {
    const formData = {
      ownerId: id,
    };
    UserService.getOwnerDetailsById(formData).then((response) => {
      if (response.isSuccess) {
        setInitialItem({
          profileImage: response.data.data.companyImage,
          id: response.data.data.id,
          representativeName: response.data.data.representativeName,
          email: response.data.data.email,
          nid: response.data.data.NID,
          vat: response.data.data.VAT,
          companyName: response.data.data.companyName,
          businessName: response.data.data.businessName,
          companyContact: response.data.data.companyContact,
          mobile: response.data.data.mobile,
          companyLocation: response.data.data.companyLocation,
          industryType: response.data.data.industryType,
          accountType: response.data.data.accountType + 1,
          username: response.data.data.userName,
          password: "",
          confirmPassword: "",
          rateCardId: response.data.data.rateCardId,
          dataRateCardId: response.data.data.dataRateCardId,
          status: response.data.data.status === 1 ? true : false,
          enableUserCreation: response.data.data.isAbleToCreateChildUser === 1 ? true : false,
          enableApiCreation: response.data.data.isApiUser === 1 ? true : false,
          enableRewardCampaignCreation: response.data.data.isDataRewardAvailable === 1 ? true : false,
          isShowRateCard: response.data.data.isRateCardShow === 1 ? true : false,
          joinedDate: response.data.data.joinedDate,
          enableReportDownload: response.data.data?.isReportDownload === 1 ? true : false,
          isCampaignNumberHash: response.data.data?.isNumberListHashed === 1 ? true : false,
          smsOperatorConfguraion: {
            all: Object.keys(response.data.data?.systemOperatorConfigurationDetails).length === 4 ? true : false,
            defaultOperator: response.data.data?.defaultOperatorId,
            robi: response.data.data?.systemOperatorConfigurationDetails[1]
              ? {
                  isUse: true,
                  isUpdate: true,
                  systemOperatorId: 1,
                  userName: response.data.data?.systemOperatorConfigurationDetails[1]?.userName,
                  tps: response.data.data?.systemOperatorConfigurationDetails[1]?.additional_data?.tps,
                  password: "",
                }
              : {
                  isUse: false,
                  isUpdate: false,
                  systemOperatorId: 1,
                  userName: "",
                  password: "",
                  tps: "",
                },
            tl: response.data.data?.systemOperatorConfigurationDetails[2]
              ? {
                  isUse: true,
                  isUpdate: true,
                  systemOperatorId: 2,
                  userName: response.data.data?.systemOperatorConfigurationDetails[2]?.userName,
                  tps: response.data.data?.systemOperatorConfigurationDetails[2]?.additional_data?.tps,
                  acode: response.data.data?.systemOperatorConfigurationDetails[2]?.additional_data?.acode,
                  password: "",
                }
              : {
                  isUse: false,
                  isUpdate: false,
                  systemOperatorId: 2,
                  userName: "",
                  password: "",
                  tps: "",
                  acode: "",
                },
            bl: response.data.data?.systemOperatorConfigurationDetails[3]
              ? {
                  isUse: true,
                  isUpdate: true,
                  systemOperatorId: 3,
                  userName: response.data.data?.systemOperatorConfigurationDetails[3]?.userName,
                  tps: response.data.data?.systemOperatorConfigurationDetails[3]?.additional_data?.tps,
                  password: "",
                  billmsisdn: response.data.data?.systemOperatorConfigurationDetails[3]?.additional_data?.billmsisdn,
                }
              : {
                  isUse: false,
                  isUpdate: false,
                  systemOperatorId: 3,
                  userName: "",
                  password: "",
                  tps: "",
                  billmsisdn: "",
                },
            gp: response.data.data?.systemOperatorConfigurationDetails[4]
              ? {
                  isUse: true,
                  isUpdate: true,
                  systemOperatorId: 4,
                  userName: response.data.data?.systemOperatorConfigurationDetails[4]?.userName,
                  tps: response.data.data?.systemOperatorConfigurationDetails[4]?.additional_data?.tps,
                  password: "",
                  billmsisdn: response.data.data?.systemOperatorConfigurationDetails[4]?.additional_data?.billmsisdn,
                }
              : {
                  isUse: false,
                  isUpdate: false,
                  systemOperatorId: 4,
                  userName: "",
                  password: "",
                  tps: "",
                  billmsisdn: "",
                },
          },
          rewardOperatorConfguraion:
            response.data.data?.isDataRewardAvailable === 1
              ? {
                  all: Object.keys(response.data.data?.dataSystemOperatorConfigurationDetails || {}).length === 4 ? true : false,
                  robi:
                    response.data.data?.dataSystemOperatorConfigurationDetails && response.data.data?.dataSystemOperatorConfigurationDetails[1]
                      ? {
                          isUse: true,
                          isUpdate: true,
                          systemOperatorId: 1,
                          userName: response.data.data?.dataSystemOperatorConfigurationDetails[1]?.username,
                          password: "",
                        }
                      : {
                          isUse: false,
                          isUpdate: false,
                          systemOperatorId: 1,
                          userName: "",
                          password: "",
                        },
                  tl:
                    response.data.data?.dataSystemOperatorConfigurationDetails && response.data.data?.dataSystemOperatorConfigurationDetails[2]
                      ? {
                          isUse: true,
                          isUpdate: true,
                          systemOperatorId: 2,
                          userName: response.data.data?.dataSystemOperatorConfigurationDetails[2]?.username || "",
                          password: "",
                        }
                      : {
                          isUse: false,
                          isUpdate: false,
                          systemOperatorId: 2,
                          userName: "",
                          password: "",
                        },
                  bl:
                    response.data.data?.dataSystemOperatorConfigurationDetails && response.data.data?.dataSystemOperatorConfigurationDetails[3]
                      ? {
                          isUpdate: true,
                          isUse: true,
                          systemOperatorId: 3,
                          userName: response.data.data?.dataSystemOperatorConfigurationDetails[3]?.username || "",
                          password: "",
                          clientId: response.data.data?.dataSystemOperatorConfigurationDetails[3]?.client_id || "",
                          grantType: response.data.data?.dataSystemOperatorConfigurationDetails[3]?.grant_type || "",
                          scope: response.data.data?.dataSystemOperatorConfigurationDetails[3]?.scope || "",
                          clientSecret: response.data.data?.dataSystemOperatorConfigurationDetails[3]?.client_secret || "",
                          senderMsisdn: response.data.data?.dataSystemOperatorConfigurationDetails[3]?.sender_msisdn || "",
                        }
                      : {
                          isUpdate: false,
                          isUse: false,
                          systemOperatorId: 3,
                          userName: "",
                          password: "",
                          clientId: "",
                          grantType: "",
                          scope: "",
                          clientSecret: "",
                          senderMsisdn: "",
                        },
                  gp:
                    response.data.data?.dataSystemOperatorConfigurationDetails && response.data.data?.dataSystemOperatorConfigurationDetails[4]
                      ? {
                          isUpdate: true,
                          isUse: true,
                          systemOperatorId: 4,
                          clientId: response.data.data?.dataSystemOperatorConfigurationDetails[4]?.client_id || "",
                          clientSecret: response.data.data?.dataSystemOperatorConfigurationDetails[4]?.client_secret || "",
                          grantType: response.data.data?.dataSystemOperatorConfigurationDetails[4]?.grant_type || "",
                        }
                      : {
                          isUpdate: false,
                          isUse: false,
                          systemOperatorId: 4,
                          clientId: "",
                          grantType: "",
                          clientSecret: "",
                        },
                }
              : {
                  all: true,
                  robi: {
                    isUpdate: true,
                    isUse: true,
                    systemOperatorId: 1,
                    userName: "",
                    password: "",
                  },
                  tl: {
                    isUse: true,
                    isUpdate: true,
                    systemOperatorId: 2,
                    userName: "",
                    password: "",
                  },
                  bl: {
                    isUse: true,
                    isUpdate: true,
                    systemOperatorId: 3,
                    userName: "",
                    password: "",
                    clientId: "",
                    grantType: "",
                    scope: "",
                    clientSecret: "",
                    senderMsisdn: "",
                  },
                  gp: {
                    isUpdate: true,
                    isUse: true,
                    systemOperatorId: 4,
                    clientId: "",
                    clientSecret: "",
                    grantType: "",
                  },
                },
        });
        const systemOperatorArray = Object.keys(response.data.data.systemOperatorConfigurationDetails).map((key) => {
          return { systemOperatorId: Number(key), ...response.data.data.systemOperatorConfigurationDetails[key] };
        });

        setSystemOperatorData(systemOperatorArray);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const fetchRateCards = () => {
    RateCardService.getRateCardListWithoutPagination().then((response) => {
      if (response.isSuccess) {
        setRateCard(
          response.data.data.map((item: any) => ({
            value: item.id,
            label: item.rateCardName,
          })),
        );
      }
    });

    RateCardService.getDigitalRateCardListWithoutPagination().then((response) => {
      if (response.isSuccess) {
        setDataRateCards(response.data.data.map((item: any) => ({ value: item.id, label: item.rateCardName })));
      }
    });
  };

  const handleClickOpen = (initialItem: UserEditValues) => {
    setOwnerData({
      id: initialItem.id,
      profileImage: initialItem.profileImage,
      representativeName: initialItem.representativeName,
      email: initialItem.email,
      nid: initialItem.nid,
      vat: initialItem.vat,
      companyName: initialItem.companyName,
      businessName: initialItem.businessName,
      companyContact: initialItem.companyContact,
      mobile: initialItem.mobile,
      companyLocation: initialItem.companyLocation,
      industryType: initialItem.industryType,
      accountType: initialItem.accountType,
      username: initialItem.username,
      password: "",
      confirmPassword: "",
      rateCardId: Number(initialItem.rateCardId),
      dataRateCardId: Number(initialItem.dataRateCardId),
      status: initialItem.status,
      enableUserCreation: initialItem.enableUserCreation,
      enableApiCreation: initialItem.enableApiCreation,
      isShowRateCard: initialItem.isShowRateCard,
      enableReportDownload: initialItem.enableReportDownload,
      isCampaignNumberHash: initialItem.isCampaignNumberHash,
      enableRewardCampaignCreation: initialItem.enableRewardCampaignCreation,
    });
    setOpen(true);
  };

  const dialog = useMemo(
    () =>
      ViewEditDialog(EditUser)({
        open: open,
        setOpen: setOpen,
        dialogTitle: "Update User",
        initialItem: ownerData,
        fetchData: fetchUser,
        theme: theme,
        maxWidth: "lg",
        initialData: { rateCard: rateCard, dataRateCard: dataRateCard },
      }),
    [open],
  );

  // const dialogChangePassword = useMemo(() => ViewEditDialog(ChangePassword)({
  //     open: open,
  //     setOpen: setOpen,
  //     dialogTitle: dialogTitle,
  //     initialItem: initialItem,
  //     fetchData: fetchUser,
  //     theme: theme,
  //     maxWidth: "md"
  // }), [open]);

  return (
    <Grid container justifyContent={"center"} spacing={1}>
      <Grid item lg={11} md={12} xs={12}>
        <Typography sx={{ ...theme.typography.pageheader }}>
          <ManageAccountsIcon fontSize="medium" />
          User Management
        </Typography>
      </Grid>
      {Number(user?.role) !== 4 && (
        <Grid item xs={12}>
          <Fab
            color="primary"
            sx={{ position: "fixed", zIndex: 3, bottom: 16, right: 16 }}
            aria-label="edit"
            onClick={() => {
              _setImage(`${process.env.REACT_APP_API_PROD}/${initialItem.profileImage}`, "user_profile_pic").then((value) => {
                const initialState = {
                  ...initialItem,
                  profileImage: value,
                };
                handleClickOpen(initialState);
              });
            }}
          >
            <EditIcon />
          </Fab>
        </Grid>
      )}
      <Grid item xs={12}>
        <Grid container spacing={gridSpacing}>
          <Grid item xs={12}>
            <Grid container columnSpacing={gridSpacing} display="flex" justifyContent="center" alignItems="center">
              <Grid item lg={10} md={10} sm={12} xs={12}>
                <Grid container>
                  <Grid item xs={6}>
                    <Button
                      color="inherit"
                      onClick={() => {
                        navigate("/config/users", { state: state });
                      }}
                      startIcon={<ArrowBackIcon />}
                    >
                      Back
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={10} md={10} sm={12} xs={12}>
                <Grid container spacing={gridSpacing}>
                  <Grid item xs={12}>
                    <UserDetailCard
                      fetchUser={fetchUser}
                      isLoading={isLoading}
                      joinedAt={moment.utc(initialItem.joinedDate).format("YYYY-MM-DD HH:mm:ss")}
                      lastLogin={initialItem.joinedDate}
                      userId={Number(id)}
                      name={initialItem.representativeName}
                      email={initialItem.email}
                      username={initialItem.username}
                      status={initialItem.status ? 1 : 0}
                      userProfilePic={String(initialItem.profileImage)}
                      color="secondary"
                      theme={theme}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard isLoading={isLoading} title={"Company Name"} detail={initialItem.companyName} color={"primary"} />
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard isLoading={isLoading} title={"Business Name"} detail={initialItem.businessName} color={"primary"} />
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard
                          isLoading={isLoading}
                          title={"Company Contact"}
                          detail={formatMobile(initialItem.companyContact)}
                          color={"primary"}
                        />
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard isLoading={isLoading} title={"Mobile"} detail={formatMobile(initialItem.mobile)} color={"primary"} />
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard
                          isLoading={isLoading}
                          title={"Industry Type"}
                          detail={INDUSTRY_TYPES.find((o: any) => o.value === initialItem.industryType)?.label || ""}
                          color={"primary"}
                        />
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard
                          isLoading={isLoading}
                          title={"Account Type"}
                          detail={ACCOUNT_TYPES.find((o: any) => o.value === initialItem.accountType)?.label || ""}
                          color={"primary"}
                        />
                      </Grid>
                      {/* <Grid item lg={3} md={4} sm={4} xs={6}>
                                                <UserInfoCard
                                                    isLoading={isLoading}
                                                    title={'NID'}
                                                    detail={ownerData.nid}
                                                    color={'orange'}/>
                                            </Grid> */}
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard isLoading={isLoading} title={"VAT"} detail={initialItem.vat} color={"orange"} />
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={6}>
                        <UserInfoCard isLoading={isLoading} title={"Username"} detail={initialItem.username} color={"red"} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {Number(user?.role) !== 4 && (
                  <Grid container spacing={gridSpacing}>
                    <Grid item xs={12} mt={2}>
                      <CredentialsManagement id={1} userId={id} fetchData={fetchUser} title="System Operators" operationCosts={initialItem} />
                    </Grid>
                  </Grid>
                )}
                {Number(user?.role) !== 4 && initialItem?.enableRewardCampaignCreation && (
                  <Grid container spacing={gridSpacing}>
                    <Grid item xs={12} mt={2}>
                      <DataCredentialsManagement id={1} userId={id} fetchData={fetchUser} title="System Operators" operationCosts={initialItem} />
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {dialog}
    </Grid>
  );
}

export default ViewUser;
